module.exports = __webpack_public_path__ + "static/media/DSC00918-7.2263775f.jpg";